import { Grid, Box, Typography, Button, Theme, styled } from '@quillbot/design-system';
import { makeStyles, withTheme } from '@quillbot/design-system';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  label: {
    fontSize: '19px',
    textTransform: 'capitalize',
    [theme.breakpoints.down('lg')]: {
      paddingRight: 'inherit',
    },
  },
  multiBox: {
    maxWidth: '219px',
    width: '100%',
    padding: 0,
    margin: '20px',
  },
  h1: {
    fontSize: '30px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    margin: '0px 0px 0px 5px',
  },
  h5: {
    fontWeight: 'bold',
  },
  headingMonth: {
    fontWeight: 'bold',
    fontSize: '25px',
  },
  bestValueBox: {
    alignItems: 'center',
    width: '100%',
    maxWidth: '219px',
    background: '#dc9e00',
    boxShadow: '15px',
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '15px 15px 0px 0px',
    border: `1px solid ${theme.palette.divider}`,
    borderBottom: '0px',
  },
  premiumBox: {
    width: 'max-content',
    height: '241px',
    background: 'white',
    maxWidth: '219px',
    padding: '15px',
    boxShadow: '15px',
    position: 'relative',
    overflow: 'hidden',
    margin: '20px',
    marginTop: '55px',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '15px',
  },
  premiumBoxValue: {
    width: 'max-content',
    height: '241px',
    background: 'white',
    maxWidth: '219px',
    padding: '15px',
    boxShadow: '15px',
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '0px 0px 15px 15px',
    border: `1px solid ${theme.palette.divider}`,
    borderTop: '0px',
  },
  bestValueText: {
    color: 'white',
    fontSize: '15px',
    fontWeight: 'bold',
    alignItems: 'center',
    padding: '3px',
  },
  boxTitle: {
    display: 'flex',
    fontSize: '30px',
    fontWeight: 'bolder',
    alignItems: 'baseline',
  },
  holderBox: {
    backgroundColor: 'white',
    boxShadow: '30px',
    padding: '0px 37px 0px',
    width: 'max-content',
  },
  holderBorder: {
    borderColor: 'rgba(76, 148, 90, 0.44)',
    '&:hover': {
      background: `${theme.palette.primary.dark}14`,
      // border: `4px solid ${theme.palette.primary.dark}`,
    },
  },
  boxBtn: {
    width: '50%',
    margin: '10px 10px 10px 0px',
  },
  saveInfo: {
    fontSize: '15px',
    fontWeight: 'bold',
  },
  holderLabel: {
    backgroundColor: 'white',
  },
  footerText: {
    fontSize: '13px',
    color: '#8d9094',
  },
  pricePoint: {
    display: 'flex',
    alignItems: 'baseline',
  },
  pricePointFooterText: {
    fontSize: '15px',
  },
  mainGrid: {
    display: 'flex',
    width: 'max-content',
    alignItems: 'last baseline',
  },
}));
const GoldenTypography = styled(Typography)<{ featured: number }>`
  && {
    color: ${({ theme, featured }: { theme: Theme; featured: number }) =>
      featured ? theme.palette.secondary.main : theme.palette.primary.main};
  }
`;

export const CircularGoldButton = styled(Button)<{ featured: number }>`
  && {
    border-radius: 205px;
    font-weight: 600;

    background: ${({ theme, featured }: { theme: Theme; featured: number }) =>
      featured ? theme.palette.secondary.main : theme.palette.primary.main};
    &:hover {
      background: ${({ theme, featured }: { theme: Theme; featured: number }) =>
        featured ? theme.palette.secondary.dark : theme.palette.primary.dark};
    }
  }
`;

function PremiumPlanCards({ theme }: { theme: Theme }) {
  const classes = useStyles();

  return (
    <Grid className={classes.mainGrid}>
      <Box className={classes.multiBox}>
        <Box className={classes.bestValueBox}>
          <div style={{ textAlign: 'center' }}>
            <Typography className={classes.bestValueText}>Best Value</Typography>
          </div>
        </Box>
        <Box className={`${classes.premiumBoxValue}`}>
          <Typography className={classes.headingMonth}>Annual</Typography>
          <div className={classes.pricePoint}>
            <Typography className={classes.boxTitle}>$6.67</Typography>
            <Typography className={classes.pricePointFooterText}>per month</Typography>
          </div>
          <GoldenTypography color="secondary" featured={1} className={classes.saveInfo}>
            Save 55%
          </GoldenTypography>
          <CircularGoldButton variant="contained" color="secondary" featured={1} className={classes.boxBtn}>
            Select
          </CircularGoldButton>
          <Typography className={classes.footerText}>Billed $79.95 USD every 12 months</Typography>
        </Box>
      </Box>

      <Box className={`${classes.premiumBox}`}>
        <Typography className={classes.headingMonth}>Semi Annual</Typography>
        <div className={classes.pricePoint}>
          <Typography className={classes.boxTitle}>$6.67</Typography>
          <Typography className={classes.pricePointFooterText}>per month</Typography>
        </div>
        <GoldenTypography color="primary" featured={0} className={classes.saveInfo}>
          Save 33%
        </GoldenTypography>
        <CircularGoldButton variant="contained" color="primary" featured={0} className={classes.boxBtn}>
          Select
        </CircularGoldButton>
        <Typography className={classes.footerText}>Billed $59.95 USD every 6 months</Typography>
      </Box>

      <Box style={{}} className={`${classes.premiumBox}`}>
        <Typography className={classes.headingMonth}>Monthly</Typography>
        <div className={classes.pricePoint} style={{ marginBottom: '22px' }}>
          <Typography className={classes.boxTitle}>$14.95</Typography>
          <Typography className={classes.pricePointFooterText}>per month</Typography>
        </div>
        <CircularGoldButton variant="contained" color="primary" featured={0} className={classes.boxBtn}>
          Select
        </CircularGoldButton>
        <Typography className={classes.footerText}>Billed monthly</Typography>
      </Box>
    </Grid>
  );
}

export default withTheme<Theme, React.FunctionComponent<{ theme: Theme }>>(PremiumPlanCards);
